function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from "react";
import Button from "react-bootstrap/Button";
import moment from "moment-timezone";
import { FilterContext, UserContext, SearchContext } from "../index";
import { useQuery, useMutation } from "@apollo/client";
import Loader from "../Loader/Loader";
import { toast } from "react-toastify";
import { GET_MANUAL_LISTING_QUERY, ADD_MANUAL_TASK_MUTATION, DELETE_MANUAL_TASK_MUTATION } from "../ManualPages/query";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import DatePicker from "react-datepicker";
import Table from "react-bootstrap/Table";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import format from "date-fns/format";
import "./AddManualTime.css";
import { Field, Form as FormikForm, Formik } from "formik";
import * as Yup from "yup";
import { MANUAL_TIME_HEADER_DETAILS_QUERY } from "./query";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PROJECTS_LISTING_QUERY } from "../ManualPages/query";
import { GoCalendar } from "react-icons/go";
import { arrayToStringOutput } from "../SideMenu/Header";
import TimePicker from "rc-time-picker";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { VscLoading } from "react-icons/vsc";
import { UNREVIEWED_MANUAL_TIME_QUERY, GET_REVIEW_MANUAL_TIME_COUNT_QUERY } from "./../ManualTimeEntriesReview/query";
var MANUAL_LIMIT = 10;
var manualOffsets = 0;
var ManualSchema = Yup.object().shape({
  manualdescription: Yup.string().trim().required("Required"),
  manualStartTime: Yup.string().required("Required"),
  manualEndTime: Yup.string().required("Required")
});
var AddManualTime = function AddManualTime(props) {
  var _manualListingData$ge, _manualListingData$ge2;
  var location = props.location,
    activeManualTab = props.activeManualTab;
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;

  //   const { organisationId, organisationSettings, users, location } = props;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    manualFilterDate = _React$useState2[0],
    setManualFilterDate = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isManualFilterDatePickerOpen = _React$useState4[0],
    setIsManualFilterDatePickerOpen = _React$useState4[1];

  //   //loadmore
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isAllLoaded = _React$useState6[0],
    setIsAllLoaded = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadingMore = _React$useState8[0],
    setIsLoadingMore = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadMoreButton = _React$useState10[0],
    setIsLoadMoreButton = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    manualTaskInfoModal = _React$useState12[0],
    toggleManualTaskInfoModal = _React$useState12[1];
  var _useQuery = useQuery(MANUAL_TIME_HEADER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: user.userId
      }
    }),
    manualTimeHeaderData = _useQuery.data,
    manualTimeHeaderError = _useQuery.error,
    manualTimeHeaderLoading = _useQuery.loading,
    manualHeaderRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(GET_MANUAL_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: user.userId,
        startDate: manualFilterDate ? Number(moment(manualFilterDate).startOf("day").format("x")) : null,
        endDate: manualFilterDate ? Number(moment(manualFilterDate).endOf("day").format("x")) : null,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: MANUAL_LIMIT,
        offset: 0
      }
    }),
    manualListingData = _useQuery2.data,
    manualListingError = _useQuery2.error,
    manualListingLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    manualRefetch = _useQuery2.refetch;
  React.useEffect(function () {
    manualHeaderRefetch === null || manualHeaderRefetch === void 0 ? void 0 : manualHeaderRefetch();
    manualRefetch === null || manualRefetch === void 0 ? void 0 : manualRefetch();
  }, [location === null || location === void 0 ? void 0 : location.key, activeManualTab]);
  if ((manualListingData === null || manualListingData === void 0 ? void 0 : (_manualListingData$ge = manualListingData.getManualTaskDetails) === null || _manualListingData$ge === void 0 ? void 0 : _manualListingData$ge.length) !== 0 && (manualListingData === null || manualListingData === void 0 ? void 0 : (_manualListingData$ge2 = manualListingData.getManualTaskDetails) === null || _manualListingData$ge2 === void 0 ? void 0 : _manualListingData$ge2.length) < MANUAL_LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }

  //   const handleFilterChange = (e) => {
  //     setIsManualFilterDatePickerOpen(!isManualFilterDatePickerOpen);
  //     setManualFilterDate(e);
  //   };

  return /*#__PURE__*/React.createElement("div", {
    className: "manual-time-manual-card-list-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-manual-card-header-section"
  }, /*#__PURE__*/React.createElement(ManualCardHeader, {
    manualTimeHeaderData: manualTimeHeaderData,
    manualTimeHeaderLoading: manualTimeHeaderLoading,
    manualTimeHeaderError: manualTimeHeaderError
  })), /*#__PURE__*/React.createElement("div", {
    className: "manual-time-manual-card-list-section-"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-project-card-root"
  }, /*#__PURE__*/React.createElement(AddOfflineTask, {
    history: history,
    organisationId: organisationId,
    teamId: teamId,
    projectManagementFeature: organisationSettings.projectManagementFeature,
    organisationSettings: organisationSettings,
    user: user
  })), /*#__PURE__*/React.createElement("div", {
    className: "manual-time-manual-card-list-section-header-root"
  }, /*#__PURE__*/React.createElement(ManualTimeTaskList, {
    manualTaskInfoModal: manualTaskInfoModal,
    toggleManualTaskInfoModal: toggleManualTaskInfoModal,
    manualFilterDate: manualFilterDate,
    isManualFilterDatePickerOpen: isManualFilterDatePickerOpen,
    manualListingData: manualListingData,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsLoadingMore: setIsLoadingMore,
    fetchMore: fetchMore,
    setIsAllLoaded: setIsAllLoaded,
    manualListingLoading: manualListingLoading,
    manualListingError: manualListingError,
    organisationId: organisationId,
    user: user,
    manualRefetch: manualRefetch,
    organisationSettings: organisationSettings,
    setIsManualFilterDatePickerOpen: setIsManualFilterDatePickerOpen,
    setManualFilterDate: setManualFilterDate,
    role: role
  }))));
};
var ManualCardHeader = function ManualCardHeader(props) {
  var _manualTimeHeaderData, _manualTimeHeaderData2, _manualTimeHeaderData3, _manualTimeHeaderData4;
  var manualTimeHeaderData = props.manualTimeHeaderData,
    manualTimeHeaderLoading = props.manualTimeHeaderLoading,
    manualTimeHeaderError = props.manualTimeHeaderError;

  // if (manualTimeHeaderLoading) {
  //   return <Loader />;
  // }

  // if (manualTimeHeaderError) {
  //   return <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>;
  // }

  // if (!manualTimeHeaderData) {
  //   return null;
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: "manual-time-manual-card-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card summary-hover-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card-title text-dark"
  }, "Submitted Manual Time"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, manualTimeHeaderLoading ? /*#__PURE__*/React.createElement(VscLoading, {
    className: "review-loading-svg"
  }) : manualTimeHeaderError || !manualTimeHeaderData ? " " : manualTimeHeaderData === null || manualTimeHeaderData === void 0 ? void 0 : (_manualTimeHeaderData = manualTimeHeaderData.manualTimeHeaderDetails) === null || _manualTimeHeaderData === void 0 ? void 0 : _manualTimeHeaderData.submittedTaskCount)), /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card summary-hover-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card-title text-dark"
  }, "Approved Manual Time"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, manualTimeHeaderLoading ? /*#__PURE__*/React.createElement(VscLoading, {
    className: "review-loading-svg"
  }) : manualTimeHeaderError || !manualTimeHeaderData ? " " : manualTimeHeaderData === null || manualTimeHeaderData === void 0 ? void 0 : (_manualTimeHeaderData2 = manualTimeHeaderData.manualTimeHeaderDetails) === null || _manualTimeHeaderData2 === void 0 ? void 0 : _manualTimeHeaderData2.approvedTaskCount)), /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card summary-hover-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card-title text-dark"
  }, "Rejected Manual Time"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, manualTimeHeaderLoading ? /*#__PURE__*/React.createElement(VscLoading, {
    className: "review-loading-svg"
  }) : manualTimeHeaderError || !manualTimeHeaderData ? " " : manualTimeHeaderData === null || manualTimeHeaderData === void 0 ? void 0 : (_manualTimeHeaderData3 = manualTimeHeaderData.manualTimeHeaderDetails) === null || _manualTimeHeaderData3 === void 0 ? void 0 : _manualTimeHeaderData3.rejectedTaskCount)), /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card summary-hover-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-dashboard-card-title text-dark"
  }, "Pending Manual Time"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, manualTimeHeaderLoading ? /*#__PURE__*/React.createElement(VscLoading, {
    className: "review-loading-svg"
  }) : manualTimeHeaderError || !manualTimeHeaderData ? " " : manualTimeHeaderData === null || manualTimeHeaderData === void 0 ? void 0 : (_manualTimeHeaderData4 = manualTimeHeaderData.manualTimeHeaderDetails) === null || _manualTimeHeaderData4 === void 0 ? void 0 : _manualTimeHeaderData4.pendingTaskCount))));
};
var AddOfflineTask = function AddOfflineTask(props) {
  var history = props.history,
    organisationId = props.organisationId,
    teamId = props.teamId,
    projectManagementFeature = props.projectManagementFeature,
    organisationSettings = props.organisationSettings,
    user = props.user;
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    manualAddedShow = _React$useState14[0],
    setManualAddedShow = _React$useState14[1];
  var _React$useState15 = React.useState(new Date()),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    taskStartDate = _React$useState16[0],
    setTaskStartDate = _React$useState16[1];
  var _React$useState17 = React.useState(""),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    modalManualStartTime = _React$useState18[0],
    setModalManualStartTime = _React$useState18[1];
  var _React$useState19 = React.useState(""),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    modalManualEndTime = _React$useState20[0],
    setModalManualEndTime = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isNavClick = _React$useState22[0],
    setNavClick = _React$useState22[1];
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    projectError = _React$useState24[0],
    setProjectError = _React$useState24[1];
  var _React$useState25 = React.useState(""),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    manualTimeError = _React$useState26[0],
    setManualTimeError = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isTaskDatePickerOpen = _React$useState28[0],
    setIsTaskDatePickerOpen = _React$useState28[1];
  var _React$useState29 = React.useState(undefined),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    modalManualValueEndTime = _React$useState30[0],
    setModalManualValueEndTime = _React$useState30[1];
  var _React$useState31 = React.useState(undefined),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    modalManualValueStartTime = _React$useState32[0],
    setModalManualValueStartTime = _React$useState32[1];
  var _React$useState33 = React.useState(null),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    startTimeTemp = _React$useState34[0],
    setStartTimeTemp = _React$useState34[1];
  var _React$useState35 = React.useState(null),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    endTimeTemp = _React$useState36[0],
    setEndTimeTemp = _React$useState36[1];
  var formats = "h:mm a";
  var _useQuery3 = useQuery(PROJECTS_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        from: props !== null && props !== void 0 && props.from ? "desktop" : null
      },
      skip: !organisationId || !teamId
    }),
    projectListing = _useQuery3.data,
    projectListingError = _useQuery3.error,
    projectListingLoading = _useQuery3.loading,
    projectRefetch = _useQuery3.refetch;
  var _useMutation = useMutation(ADD_MANUAL_TASK_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addManualTime = _useMutation2[0],
    addManualTimeLoading = _useMutation2[1].loading;
  var handleManualSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, _ref) {
      var resetForm, setStatus, manualdescription, variables, response, errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resetForm = _ref.resetForm, setStatus = _ref.setStatus;
            manualdescription = values.manualdescription;
            variables = {
              projectId: (manualAddedShow === null || manualAddedShow === void 0 ? void 0 : manualAddedShow.projectId) || null,
              taskId: (manualAddedShow === null || manualAddedShow === void 0 ? void 0 : manualAddedShow.taskId) || null,
              taskDescription: manualdescription,
              startTime: modalManualStartTime,
              endTime: modalManualEndTime,
              taskDate: taskStartDate,
              organisationId: organisationId,
              teamId: teamId,
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
            };
            setManualTimeError("");
            _context.prev = 4;
            _context.next = 7;
            return addManualTime({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_MANUAL_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: user.userId,
                  startDate: null,
                  endDate: null,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  limit: MANUAL_LIMIT,
                  offset: 0
                }
              }, {
                query: MANUAL_TIME_HEADER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: user.userId
                }
              }, {
                query: GET_REVIEW_MANUAL_TIME_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  limit: 20,
                  offset: 0,
                  searchText: null,
                  timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                }
              }, {
                query: UNREVIEWED_MANUAL_TIME_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  limit: 20,
                  offset: 0,
                  searchText: null,
                  timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                }
              }]
            });
          case 7:
            response = _context.sent;
            if (!(!response || !response.data || response.data.addManualTime == null)) {
              _context.next = 12;
              break;
            }
            throw new Error("error");
          case 12:
            setManualAddedShow(null);
            toast.success("Manual task added successfully!");
            setTaskStartDate(new Date());
            setModalManualValueStartTime(undefined);
            setModalManualValueEndTime(undefined);
            setStartTimeTemp(null);
            setEndTimeTemp(null);
            disabledStartTimeHours();
            disabledStartTimeMinutes();
            disabledHours();
            disabledMinutes();
            resetForm({
              manualdescription: "",
              manualStartTime: "",
              manualEndTime: ""
            });
            setStatus({
              success: true
            });
          case 25:
            _context.next = 32;
            break;
          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](4);
            setProjectError(true);
            errorMessage = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || "";
            if (errorMessage.includes("You’ve reached the limit")) {
              setManualTimeError(errorMessage.replace("GraphQL error: ", ""));
            } else {
              setManualTimeError("Something went wrong! Please try again later");
            }
          case 32:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 27]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [addManualTime, addManualTimeLoading, manualAddedShow, taskStartDate, modalManualStartTime, modalManualEndTime, teamId]);
  var handleChange = function handleChange(e) {
    setIsTaskDatePickerOpen(!isTaskDatePickerOpen);
    setTaskStartDate(e);
  };
  var startOnChange = function startOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      } else {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        if (hours == 12) hours = "00";
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setModalManualValueStartTime(value);
      setModalManualStartTime(finalTime);
      setFieldValue("manualStartTime", finalTime);
    } else {
      setModalManualStartTime("");
      setFieldValue("manualStartTime", "");
    }
  };
  var endOnChange = function endOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      } else {
        finalTime = arrData[0];
      }
      setModalManualValueEndTime(value);
      setModalManualEndTime(finalTime);
      setFieldValue("manualEndTime", finalTime);
    } else {
      setModalValueEndTime(undefined);
      setModalEndTime("");
      setFieldValue("manualEndTime", "");
    }
  };
  function check12PmStatus(value, startTimeHour, startTimeData) {
    if (value == 24 && startTimeHour <= 12 && startTimeData == "pm") {
      return false;
    }
    return true;
  }
  function disabledHours() {
    if (startTimeTemp == null) {
      return null;
    }
    var startTimeHour = moment(startTimeTemp).format("HH");
    var startTimeData = moment(startTimeTemp).format("a");
    var disabledHoursArray = [];
    for (var value = 0; value <= 24; value++) {
      if (check12PmStatus(value, startTimeHour, startTimeData) && value < Number(startTimeHour)) {
        disabledHoursArray.push(value);
      }
    }
    return disabledHoursArray;
  }
  function generateOptions(length, excludedOptions) {
    var arr = [];
    for (var value = 0; value < length; value++) {
      if (excludedOptions.indexOf(value) > 0) {
        arr.push(value);
      }
    }
    return arr;
  }
  function disabledMinutes(h) {
    if (startTimeTemp == null) {
      return null;
    }
    var startTimeHour = moment(startTimeTemp).format("HH");
    var startTimeMins = moment(startTimeTemp).format("mm");
    var startExcludeTime = [];
    for (var value = 0; value < 60; value++) {
      if (value < Number(startTimeMins)) {
        startExcludeTime.push(value);
      }
    }
    switch (h) {
      case Number(startTimeHour):
        return generateOptions(60, startExcludeTime);
      default:
        return generateOptions(60, []);
    }
  }
  function disabledStartTimeHours() {
    if (endTimeTemp == null) {
      return null;
    }
    var endTimeHour = moment(endTimeTemp).format("HH");
    var endTimeData = moment(endTimeTemp).format("a");
    var disabledHoursArray = [];
    for (var value = 0; value <= 24; value++) {
      if (check12PmStatus(value, endTimeHour, endTimeData) && value > Number(endTimeHour)) {
        disabledHoursArray.push(value);
      }
    }
    return disabledHoursArray;
  }
  function disabledStartTimeMinutes(h) {
    if (endTimeTemp == null) {
      return null;
    }
    var endTimeHour = moment(endTimeTemp).format("HH");
    var endTimeMins = moment(endTimeTemp).format("mm");
    var endExcludeTime = [];
    for (var value = 0; value < 60; value++) {
      if (value > Number(endTimeMins)) {
        endExcludeTime.push(value);
      }
    }
    switch (h) {
      case Number(endTimeHour):
        return generateOptions(60, endExcludeTime);
      default:
        return generateOptions(60, []);
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "manual-time-manual-card-root-add-section"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      manualdescription: "",
      manualStartTime: "",
      manualEndTime: ""
    },
    validationSchema: ManualSchema,
    validateOnBlur: false,
    onSubmit: handleManualSubmit
  }, function (_ref3) {
    var setFieldValue = _ref3.setFieldValue,
      isSubmitting = _ref3.isSubmitting,
      errors = _ref3.errors,
      touched = _ref3.touched,
      values = _ref3.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-project-add-card-formik"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "manualdescription"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta,
        error = fieldProps.error;
      return /*#__PURE__*/React.createElement(Form.Group, {
        className: "manual-time-project-add-card-formik-description ".concat(!projectManagementFeature ? "manual-time-project-add-card-formik-description-without-project" : "")
      }, meta.error ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement(Field, _extends({
        as: Form.Control,
        name: "manualdescription",
        type: "text",
        placeholder: "Type the description"
      }, field)));
    }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "manualStartTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(React.Fragment, null, meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "manualStartTime",
        value: modalManualValueStartTime,
        className: "manual-time-project-formik-add-form",
        onChange: function onChange(e) {
          startOnChange(e, setFieldValue);
          setStartTimeTemp(e);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true,
        inputReadOnly: true,
        focusOnOpen: true,
        disabledHours: disabledStartTimeHours,
        disabledMinutes: disabledStartTimeMinutes
      }));
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "manualEndTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(React.Fragment, null, meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "manualEndTime",
        value: modalManualValueEndTime,
        className: "manual-time-project-formik-add-form",
        onChange: function onChange(e) {
          //console.log("e", e);
          endOnChange(e, setFieldValue);
          setEndTimeTemp(e);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true,
        inputReadOnly: true,
        focusOnOpen: true,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes
      }), /*#__PURE__*/React.createElement("div", {
        className: "manual-home-project-formik-add-form-edit-end-time"
      }, modalManualValueEndTime < modalManualValueStartTime ? "End time should be greater than the start time" : ""));
    })), /*#__PURE__*/React.createElement("div", {
      className: "workfolio-manual-pages-calender-div"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      trigger: "click",
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Popover, {
        className: "page-content-wrapper-menu-filter-overlay-trigger"
      }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(DatePicker, {
        selected: taskStartDate,
        onChange: handleChange,
        open: isTaskDatePickerOpen
        // popperPlacement="top-start"
        ,
        inline: true
      })))
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-manual-pages-calender-icon-div"
    }, /*#__PURE__*/React.createElement(GoCalendar, {
      className: "workfolio-manual-pages-calender-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "workfolio-manual-pages-calender-text"
    }, arrayToStringOutput([taskStartDate, taskStartDate], organisationSettings.organisationTimezone)))))), /*#__PURE__*/React.createElement(Button, {
      variant: values.manualdescription ? "primary" : "primary",
      className: "manual-time-project-formik-add-button",
      type: "submit",
      disabled: addManualTimeLoading || modalManualValueEndTime < modalManualValueStartTime
    }, addManualTimeLoading ? "Loading..." : "Add Task")), manualTimeError ? /*#__PURE__*/React.createElement("div", {
      className: "manual-time-project-formik-add-error"
    }, manualTimeError) : null)));
  }));
};
var ManualTimeTaskList = function ManualTimeTaskList(props) {
  var _manualListingData$ge3, _manualListingData$ge4, _manualListingData$ge5;
  var manualTaskInfoModal = props.manualTaskInfoModal,
    toggleManualTaskInfoModal = props.toggleManualTaskInfoModal,
    manualFilterDate = props.manualFilterDate,
    isManualFilterDatePickerOpen = props.isManualFilterDatePickerOpen,
    manualListingData = props.manualListingData,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsLoadingMore = props.setIsLoadingMore,
    fetchMore = props.fetchMore,
    setIsAllLoaded = props.setIsAllLoaded,
    manualListingLoading = props.manualListingLoading,
    manualListingError = props.manualListingError,
    organisationId = props.organisationId,
    user = props.user,
    manualRefetch = props.manualRefetch,
    organisationSettings = props.organisationSettings,
    setIsManualFilterDatePickerOpen = props.setIsManualFilterDatePickerOpen,
    setManualFilterDate = props.setManualFilterDate,
    role = props.role;
  var _React$useState37 = React.useState(false),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    showOfflineTaskModal = _React$useState38[0],
    setShowOfflineTaskModal = _React$useState38[1];
  // const [manualTaskInfoModal, toggleManualTaskInfoModal] = React.useState(false);

  var _React$useState39 = React.useState(null),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    showDateTarget = _React$useState40[0],
    setShowDateTarget = _React$useState40[1];
  var _React$useState41 = React.useState(false),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    showDatePopup = _React$useState42[0],
    setShowDatePopup = _React$useState42[1];
  var overlayRef = React.useRef(null);
  var handleLoadMore = function handleLoadMore() {
    if (manualListingLoading) return;
    setIsLoadingMore(true);
    manualOffsets = manualOffsets + 1;
    fetchMore({
      variables: {
        offset: manualOffsets * MANUAL_LIMIT
      },
      updateQuery: function updateQuery(prev, _ref4) {
        var _fetchMoreResult$getM, _fetchMoreResult$getM2;
        var fetchMoreResult = _ref4.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getM = fetchMoreResult.getManualTaskDetails) === null || _fetchMoreResult$getM === void 0 ? void 0 : _fetchMoreResult$getM.length) === 0 && ((_fetchMoreResult$getM2 = fetchMoreResult.getManualTaskDetails) === null || _fetchMoreResult$getM2 === void 0 ? void 0 : _fetchMoreResult$getM2.length) < MANUAL_LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getManualTaskDetails: [].concat(_toConsumableArray(prev.getManualTaskDetails), _toConsumableArray(fetchMoreResult.getManualTaskDetails))
        });
      }
    });
  };
  var handleFilterChange = function handleFilterChange(e) {
    setIsManualFilterDatePickerOpen(!isManualFilterDatePickerOpen);
    setManualFilterDate(e);
    // overlayRef.handleHide();
    setShowDatePopup(!showDatePopup);
  };
  var handleShowOfflineTask = function handleShowOfflineTask(manualTaskId, taskDate, projectId, totalTimeInSec) {
    setShowOfflineTaskModal({
      manualTaskId: manualTaskId,
      taskDate: taskDate,
      projectId: projectId,
      totalTimeInSec: totalTimeInSec
    });
  };
  var handleCloseOfflineTask = function handleCloseOfflineTask() {
    setShowOfflineTaskModal(false);
  };
  var handleDateFilterClick = function handleDateFilterClick(event) {
    setShowDatePopup(!showDatePopup);
    setShowDateTarget(event.target);
  };
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return /*#__PURE__*/React.createElement(React.Fragment, null, " ", manualListingLoading ? /*#__PURE__*/React.createElement("div", {
    className: "manual-time-data-loader-div"
  }, /*#__PURE__*/React.createElement(Loader, null)) : manualListingError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement("div", {
    className: "manual-time-manual-card-table-whole-div-fixed"
  }, manualListingData !== null && manualListingData !== void 0 && (_manualListingData$ge3 = manualListingData.getManualTaskDetails) !== null && _manualListingData$ge3 !== void 0 && _manualListingData$ge3.length ? /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "manual-time-manual-card-table"
  }, /*#__PURE__*/React.createElement("tbody", {
    className: "manual-time-manual-card-table-body"
  }, manualListingData === null || manualListingData === void 0 ? void 0 : (_manualListingData$ge4 = manualListingData.getManualTaskDetails) === null || _manualListingData$ge4 === void 0 ? void 0 : _manualListingData$ge4.map(function (list, index) {
    var taskDescription = list.taskDescription,
      totalHours = list.totalHours,
      reviewStatus = list.reviewStatus,
      addedAt = list.addedAt,
      reviewedName = list.reviewedName,
      projectName = list.projectName,
      taskDate = list.taskDate,
      manualTaskId = list.manualTaskId,
      startTime = list.startTime,
      endTime = list.endTime,
      projectId = list.projectId,
      totalTimeInSec = list.totalTimeInSec;
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? /*#__PURE__*/React.createElement("tr", {
      className: "manual-time-manual-card-table-header"
    }, /*#__PURE__*/React.createElement("td", null, "Manual Time Description"), /*#__PURE__*/React.createElement("td", null, "Duration"), /*#__PURE__*/React.createElement("td", null, "Worked Time"), /*#__PURE__*/React.createElement("td", null, "Date"), /*#__PURE__*/React.createElement("td", null, "Review Status"), /*#__PURE__*/React.createElement("td", null)) : null, /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "manual-time-manual-card-table-data-details manual-time-manual-card-table-data-details-".concat(reviewStatus == null ? "pending" : reviewStatus)
    }, /*#__PURE__*/React.createElement("td", {
      className: ""
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskDescription)
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-manual-card-table-description"
    }, taskDescription === "" ? "-" : taskDescription)), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-poject",
        className: "project-tooltip-start"
      }, projectName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-project-card-table-name"
    }, projectName))), /*#__PURE__*/React.createElement("td", {
      className: ""
    }, totalHours), /*#__PURE__*/React.createElement("td", null, startTime, " - ", endTime), /*#__PURE__*/React.createElement("td", null, " ", /*#__PURE__*/React.createElement("span", null, moment().tz(currentTimezone).format("MMM DD YYYY") == moment(Number(taskDate)).tz(currentTimezone).format("MMM DD YYYY") ? "Today" : moment().subtract(1, "days").tz(currentTimezone).format("MMM DD YYYY") == moment(Number(taskDate)).tz(currentTimezone).format("MMM DD YYYY") ? "Yesterday" : moment(Number(taskDate)).format("DD-MMM-yyyy"))), /*#__PURE__*/React.createElement("td", {
      className: "manual-time-manual-card-table-data-review-status-".concat(reviewStatus == null ? "pending" : reviewStatus),
      title: reviewStatus === null ? "Yet to approved by admin/head" : ""
    }, reviewStatus === "rejected" || reviewStatus === "approved" ? "".concat(reviewStatus.charAt(0).toUpperCase() + reviewStatus.slice(1), " by ").concat(reviewedName) : "Pending Review"), reviewStatus !== "approved" && reviewStatus !== "rejected" || role == "Admin" ? /*#__PURE__*/React.createElement("td", {
      className: "manual-time-manual-table-data-icon",
      title: "delete",
      onClick: function onClick() {
        return handleShowOfflineTask(manualTaskId, taskDate, projectId, totalTimeInSec);
      }
    }, "Delete") : /*#__PURE__*/React.createElement("td", null)));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "no-data-risk-setting manual-task-list-no-data-found"
  }, manualFilterDate ? "There is no manual task found ".concat(manualFilterDate ? "for \n              ".concat(format(Number(manualFilterDate), "d LLL, yyyy")) : "", ".") : "Yet to add a manual time."), manualListingData !== null && manualListingData !== void 0 && (_manualListingData$ge5 = manualListingData.getManualTaskDetails) !== null && _manualListingData$ge5 !== void 0 && _manualListingData$ge5.length ? /*#__PURE__*/React.createElement("div", {
    className: "manual-time-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "manual-time-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) :
  // <p className="manual-time-manual-card-table-data-all-task-label">You have seen all the tasks</p>
  null) : null), /*#__PURE__*/React.createElement(DeleteOfflineTaskModal, {
    showOfflineTaskModal: showOfflineTaskModal,
    handleCloseOfflineTask: handleCloseOfflineTask,
    organisationId: organisationId,
    userId: user.userId,
    startDate: manualFilterDate,
    endDate: manualFilterDate,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    manualRefetch: manualRefetch
  }));
};
export var DeleteOfflineTaskModal = function DeleteOfflineTaskModal(props) {
  var showOfflineTaskModal = props.showOfflineTaskModal,
    handleCloseOfflineTask = props.handleCloseOfflineTask,
    organisationId = props.organisationId,
    userId = props.userId,
    startDate = props.startDate,
    endDate = props.endDate,
    timeZone = props.timeZone,
    manualRefetch = props.manualRefetch;
  if (showOfflineTaskModal === false) {
    return null;
  }
  var manualTaskId = showOfflineTaskModal.manualTaskId,
    projectId = showOfflineTaskModal.projectId,
    taskDate = showOfflineTaskModal.taskDate,
    totalTimeInSec = showOfflineTaskModal.totalTimeInSec;
  var _React$useState43 = React.useState(false),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    deleteStatus = _React$useState44[0],
    setDeleteStatus = _React$useState44[1];
  var _React$useState45 = React.useState(false),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    reviewStatusValue = _React$useState46[0],
    setReviewStatusValue = _React$useState46[1];
  var _useMutation3 = useMutation(DELETE_MANUAL_TASK_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    deleteManualTask = _useMutation4[0],
    deleting = _useMutation4[1].loading;
  var handleDelete = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _response$data, _response$data2, _response$data3, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!deleting) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return deleteManualTask({
              variables: {
                organisationId: organisationId,
                manualTaskId: manualTaskId,
                projectId: projectId,
                taskDate: moment(taskDate),
                totalTimeInSec: Number(totalTimeInSec)
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_MANUAL_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  startDate: Number(moment(startDate).startOf("day").format("x")),
                  endDate: Number(moment(endDate).endOf("day").format("x")),
                  timeZone: timeZone
                }
              }, {
                query: MANUAL_TIME_HEADER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId
                }
              }]
            });
          case 5:
            response = _context2.sent;
            if (response && response !== null && response !== void 0 && response.data && (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.deleteManualTask) == "true") {
              toast.success("Manual Task deleted successfully!");
              setDeleteStatus(true);
              manualRefetch === null || manualRefetch === void 0 ? void 0 : manualRefetch();
              handleCloseOfflineTask();
            } else if (response && response !== null && response !== void 0 && response.data && ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.deleteManualTask) == "approved" || (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.deleteManualTask) == "rejected")) {
              setReviewStatusValue(true);
            } else {
              setReviewStatusValue(false);
              toast.success("Error, try again");
            }
            _context2.next = 11;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 9]]);
    }));
    return function handleDelete() {
      return _ref5.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: showOfflineTaskModal,
    onHide: handleCloseOfflineTask,
    "data-backdrop": "false",
    className: "task-tracker-offline-task-delete-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Task")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure to delete this task?"), /*#__PURE__*/React.createElement(Modal.Footer, {
    className: "manual-time-delete-task-details-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-delete-task-details-button-div"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handleCloseOfflineTask();
    },
    disabled: deleting
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleDelete();
    },
    disabled: reviewStatusValue || deleting
  }, deleting ? "Loading..." : deleteStatus === true ? "Deleted" : "Delete Task")), /*#__PURE__*/React.createElement("div", {
    className: "manual-time-delete-task-details-review-status"
  }, reviewStatusValue ? /*#__PURE__*/React.createElement("div", null, "You can't delete the reviewed task") : null)));
};
export default AddManualTime;